const BASE_URL = `${process.env.VUE_APP_API_DOMAIN}${process.env.VUE_APP_API_PATH}`; // domain/api
const FRONT_URL = `${process.env.VUE_APP_API_DOMAIN}${process.env.VUE_APP_API_FRONT_PATH}`; // domain/api
const API_DOMAIN = `${process.env.VUE_APP_API_DOMAIN}`;
const FRONT_DOMAIN = `${process.env.VUE_APP_FRONT_DOMAIN}`;
const GMAPS_KEY = `${process.env.VUE_APP_GMAPS_KEY}`;
const RECAPTCHA_KEY = `${process.env.VUE_APP_RECAPTCHA}`;
const SECRET_KEY = `${process.env.VUE_APP_SECRET_KEY}`;
const GTM_CODE = 'GTM-PVNSTWM';

const BASE_API = `${BASE_URL}${process.env.VUE_APP_API_BASE}`;  // domain/api/base
const ADMIN_API = `${BASE_URL}${process.env.VUE_APP_API_ADMIN}`;   // domain/api/admin
const CLIENT_API = `${BASE_URL}${process.env.VUE_APP_API_CLIENT}`;   // domain/api/client
const CLIENT_APP_API = `${BASE_URL}${process.env.VUE_APP_API_CLIENT_APP}`; // domain/api/app

const CLIENT_API_CREDENTIALS = {
  id: `${process.env.VUE_APP_CLIENT_APP_ID}`,
  email: `${process.env.VUE_APP_CLIENT_APP_MAIL}`,
  pass: `${process.env.VUE_APP_CLIENT_APP_PASS}`,
  name: `${process.env.VUE_APP_CLIENT_APP_NAME}`,
  role: "APPLICATION"
};

export const REGISTER_ID = 'register_id';


const FRANQUICIADO = "Franchisee";
const ADMINISTRADOR = "Administrator";
const GESTOR = "Manager";

const FRANQUICIADO_MODEL = '\\App\\Models\\Franchisee\\Franchisees';
const ADMINISTRADOR_MODEL = "\\App\Models\\Admin\\Administrators";
const GESTOR_MODEL = "\\App\\Models\\Manager\\Managers";

const PLAN_BASE_MODEL = 'App\\Models\\Base\\Plans\\PlanBase';
const PLAN_24H_MODEL = "App\\Models\\Base\\Plans\\Plan24h";
const PLAN_NOCHE_MODEL = "App\\Models\\Base\\Plans\\PlanNoche";
const PLAN_FIN_SEMANA_MODEL = "App\\Models\\Base\\Plans\\PlanFinSemana";
const PLAN_CUATRO_DIAS_MODEL = "App\\Models\\Base\\Plans\\PlanCuatroDias";
const PLAN_SEMANAL_MODEL = "App\\Models\\Base\\Plans\\PlanSemanal";
const PLAN_SEMANAL_EJECUTIVO_MODEL = "App\\Models\\Base\\Plans\\PlanSemanalEjecutivo";
const PLAN_MENSUAL_EJECUTIVO_MODEL = "App\\Models\\Base\\Plans\\PlanMensualEjecutivo";
const PLAN_MENSUAL_NOCHES_MODEL = "App\\Models\\Base\\Plans\\PlanMensualNoches";
const PLAN_MENSUAL_MODEL = "App\\Models\\Base\\Plans\\PlanMensual";
const PLAN_LIBRE_MODEL = "App\\Models\\Base\\Plans\\PlanLibre";

const PRODUCTO_PER_MINUTE_MODEL = "App\\Models\\Base\\ParkingsPlansClientsPerMinutes";

// const BASE_OLD = `${process.env.VUE_APP_API_OLD}`;
// const IS_OLD_API = process.env.VUE_APP_IS_API_OLD === "true" ? true : false;

export const MANTENIMIENTO = process.env.VUE_APP_MANTENIMIENTO === "true" ? true : false;

export const STATUS_NEW = "NEW";
export const STATUS_WAITING_PHONE = "WAITING_PHONE";
export const STATUS_PHONE_VERIFIED = "PHONE_VERIFIED";
export const STATUS_WAITING_CREDIT_CARD = "WAITING_CREDIT_CARD";
export const STATUS_CREDIT_CARD_ERROR = "CREDIT_CARD_ERROR";
export const STATUS_REGISTERED = "REGISTERED";
export const STATUS_REGISTERED_NO_ACCESS = "REGISTERED_NO_ACCESS";

// Datos empresa
export const MIMOTO_PHONE = {
  number: 965753644,
  label: '965 753 644'
}

// 669 62 49 50
export const MIMOTO_WHATSAPP = {
  number: 669624950,
  label: '669 62 49 50'
}

export const MIMOTO_MAIL = {
  label: 'hola@mimotoparking.com'
}

export const MIMOTO_MAIL_CLIENTS = {
  label: 'clientes@mimotoparking.com'
}

//////////////////////////
export const CORPORATION_PHONE = {
  number: 965753644,
  label: '965 753 644'
}

export const CORPORATION_WHATSAPP = {
  number: 699624950,
  label: '669 62 49 50'
}

export const CORPORATION_MAIL = {
  label: 'hola@mimotoparking.com'
}

export const CORPORATION_MAIL_CLIENTS = {
  label: 'clientes@mimotoparking.com'
}

export const URL_CORPORATION = 'https://mimotoparking.com';
export const URL_CORPORATION_CONTACT = 'https://mimotoparking.com/contacto/';

export const COMPANY_DATA = {
  url_company: 'https://www.mimotoparking.com',
  url_contact: 'https://mimotoparking.com/contacto/',
  company_name: `${process.env.VUE_APP_COMPANY_NAME}` ? `${process.env.VUE_APP_COMPANY_NAME}` : 'MimoTo Parking',
  company_simple: `${process.env.VUE_APP_COMPANY_NAME_SIMPLE}` ? `${process.env.VUE_APP_COMPANY_NAME_SIMPLE}` : 'MimoTo',
  email: `${process.env.VUE_APP_CLIENT_APP_MAIL}`,
  vehiculo: 'moto, bici o patinete',
  cookies: 'https://www.mimotoparking.com/politica-de-cookies',
  privacidad: 'https://www.mimotoparking.com/politica-privacidad/',
  condiciones: 'https://mimotoparking.com/condiciones-contrato/',
  redes: {
    facebook: 'https://www.facebook.com/mimotoparking/',
    instagram: 'https://www.instagram.com/mimotoparking/',
    twitter: 'https://twitter.com/mimotoparking',
    linkedin: 'https://www.linkedin.com/company/mimotoparking/'
  }
};



export const registerRoutes = [
  "Personal",
  "PersonalA", // test A / B
  "PersonalB", // test A / B
  "Telefono",
  'Contraseña',
  "CreditCard",
  "Acceso",
  'email-ya-verificado', 
  'email-verificado',
  "tpv-pago-ko",
  "tpv-pago-ok",
  "tpv-order",
  "TpvOrder",
  "TpvResponse",
  "tpv-response",
  "expiredLink",
  "Maintenance",
  "cuentaBorrada",
  "DeletedClient",
  "Persona de Contacto" // ruta origen eliminar cuenta
  // "cuenta-eliminada"
];



// `https://api.mimotov2.trestristestigres.com/api/base/parkings-images`;
const IMAGES_URL = `${BASE_API}/parkings-images`;

// photoTypes
export const PHOTO_TYPES = [
  { value: "other", label: "Foto"},
  { value: "map", label : "Plano"},
]

// labelIcon
export const LABEL_ICON = {
  labelOn: '\u2713',
  labelOff: '\u2715'
}

// lang
export const CALENDAR_LANG = {
  formatLocale: {
    firstDayOfWeek: 1,
    weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    placeholder: {
      date: 'Selecciona una Fecha',
      dateRange: 'Selecciona un Rango de Fechas'
    }
  },
  // monthBeforeYear: false,
}

// trialStatus
// 'NOT_ACTIVE','FREE','OCCUPIED','FINISHED','CANCELLED'
export const TRIAL_STATUS = [
  { value: 'NOT_ACTIVE', label: 'Activo (próximamante)'}, // Desactivado // fuera de fecha / no iniciado // sin empezar
  { value: 'FINISHED', label : 'Caducado'},  // fuera de fecha // terminado

  { value: 'OCCUPIED', label : 'Activo Ocupado'},
  { value: 'FREE', label : 'Activo no Ocupado'}, // no ocupado // no contamos con su plaza
  { value: 'ACTIVE', label : 'Activo Todos'}, // OCCUPIED y FREE

  { value: 'CANCELLED', label : 'Cancelado'},
]

// parkingPlansClients status
// 'NOT_ACTIVE','FREE','RESERVED','OCCUPIED','FINISHED','CANCELLED'
export const PLANS_CLIENTS_STATUS = [
  { value: 'NOT_ACTIVE', label: 'Activo (próximamante)'},  // Desactivado, Sin Empezar
  { value: 'FINISHED', label : 'Caducado'},

  { value: 'OCCUPIED', label : 'Activo Ocupado'},
  { value: 'RESERVED', label : 'Activos Reservado'},
  { value: 'FREE', label : 'Activo no Ocupado'}, // no ocupado, sin reserva
  { value: 'ACTIVE', label : 'Activo Todos'}, // OCCUPIED, RESERVED y FREE

  { value: 'CANCELLED', label : 'Cancelado'},
]

// parkingPlansClientsPerMinutes status
// 'OCCUPIED','FINISHED','CANCELLED'
export const PLANS_CLIENTS_BASE_STATUS = [
  { value: 'OCCUPIED', label : 'Activo Ocupado'},
  { value: 'FINISHED', label : 'Caducado'},
  { value: 'CANCELLED', label : 'Cancelado'},
  // { value: 'ACTIVE', label : 'Activo'}, // === OCCUPIED
]


// paymentStatus
export const PAYMENT_STATUS = [
  { value: 'PENDING_PAYMENT', label: 'Pago pendiente'},
  { value: 'PAID', label : 'Pagado'},
  { value: 'CANCELLED', label : 'cancelado'},
]

export const PAYMENT_TYPE = [
  { value: 'AUTO', label: 'Pago automático tarjeta cliente'},
  { value: 'CLIENT-TPV', label : 'Envío de email con peticíon de cobro'},
]

// eventTypes
export const EVENT_TYPES = [
  { value: 'TARJETA VALIDA', label: 'Tarjeta Válida'},
  { value: 'ENTRADA MOTO', label : 'Entrada Moto'},
  { value: 'SALIDA MOTO', label : 'Salida Moto'},
  { value: 'PEATONAL', label : 'Entrada / Salida Peatonal'},
]

// cardReaderTypes
export const CARD_READER_TYPES = [
  { value: '1', label: 'Entrada'},
  { value: '2', label : 'Salida'},
  { value: '3', label : 'Peatonal'},
]

// stayingStatus
export const STAYING_TYPES = [
  { value: 'ACTIVE', label: 'Activo'},
  { value: 'FINISHED', label : 'Finalizado'},
  { value: 'CANCELLED', label : 'Cancelado'},
]

export const APP_PAGES = [
  { HOME : 'dashboard'},
  { OCUPATION: 'ocupation'},
  { GESTION: 'gestion'},
  { CONFIGURATION : 'configuracion'},
  { PARKING: 'parkings'},

  { key: 'CONFIGURATION', value : 'configuracion'},
  { key: 'CONFIGURATION', value : 'configuracion'},

]

// Tipo producto (prepago, base, custom, prueba)
export const PRODUCT_TYPES = [
  { key: 'pre_paid', value: 'parkings_plans_clients', label: 'Planes Prepago', element: 'Plan Prepago'},
  { key: 'base', value: 'parkings_plans_clients_per_minutes', label: 'Planes Base (por minuto)', element: 'Plan Base'},
  { key: 'custom',  value: 'parkings_plans_clients_customs', label: 'Planes Personalizados', element: 'Plan Personalizados'},
  { key: 'trial', value: 'parkings_plans_clients_trials', label: 'Períodos de prueba', element: 'Período de Prueba'},
];


// stayingStatus
export const TPV_RESPONSE_TYPES = {
  RC: 'RC', // Registro cliente. Add tarjeta.
  MP: 'MP', // Método de pago. Add tarjeta.
  CP: 'CP', // Constratar producto. Add tarjeta.
  PC: 'PC', // Pago producto custom. Pago seguro'
  PE: 'PE', // Pago producto extra. Pago seguro'
};


export const SEMAFORO_DATA = { BAJA: 'BAJA', MEDIA : 'MEDIA', ALTA: 'ALTA'};

// https://front.mimotov2.trestristestigres.com/#/tpv-pago-ok?r=322PE00015&h=9dedb3b9a9b91cffaa12f6b13218a28f&ret=0&i=1300

export const PREPAGO = { key: 'pre_paid', value: 'parkings_plans_clients', label: 'Planes Prepago', element: 'Plan Prepago' };
export const BASE = { key: 'base', value: 'parkings_plans_clients_per_minutes', label: 'Planes Base (por minuto)', element: 'Plan Base' };
export const CUSTOM = { key: 'custom', value: 'parkings_plans_clients_customs', label: 'Planes Personalizados', element: 'Plan Personalizado' };
export const PRUEBA = { key: 'trial', value: 'parkings_plans_clients_trials', label: 'Períodos de prueba', element: 'Período de Prueba' };

export const STAY = { key: 'stay', value: 'events_clients_stayings', label: 'Estacionamientos', element: 'Estacionamiento' };
export const EVENT = { key: 'event', value: 'events', label: 'Eventos', element: 'Evento' };
export const PAYMENT = { key: 'payment', value: 'payments', label: 'Pagos', element: 'Pago' };
export const REFOUND = { key: 'refound', value: 'refounds', label: 'Devoluciones', element: 'Devolución' };

export const PRODUCT_STORE = "datosProducto";
export const CLIENT_STORE = "datosCliente";

export const ENLACES_BLANK = process.env.VUE_APP_ENLACES_BLANK === "true" ? true : false;

export const PAYMENT_PENDING_PAYMENT = { key: 'PENDING_PAYMENT', label: 'Pago pendiente'};
export const PAYMENT_PAID =  { key:'PAID', label : 'Pagado'};
export const PAYMENT_CANCELLED =  { key:'CANCELLED', label : 'cancelado'};

// Payments products type
export const PRODUCT_PERMINUTES = { key: 'perminutes', value: 'parkings_plans_clients_per_minutes', label: 'Planes Base (por minuto)', element: 'Plan Base' };
export const PRODUCT_PREPAGO = { key: 'prepago', value: 'parkings_plans_clients', label: 'Planes Prepago', element: 'Plan Prepago' };
export const PRODUCT_CUSTOM = { key: 'custom', value: 'parkings_plans_clients_customs', label: 'Planes Personalizados', element: 'Plan Personalizado' };
export const PRODUCT_PRUEBA = { key: 'trial', value: 'parkings_plans_clients_trials', label: 'Períodos de prueba', element: 'Período de Prueba' };
export const PRODUCT_EXTRA = { key: 'extra', value: 'parkings_plans_clients_extras', label: 'Pago Independiente', element: 'Pago Independiente' };

export const DATA_FILTER = {
  parkings_id: null,
  clients_id: null,
  plans_id: null,
  credit_cards_id: null,
  payment_status: null,
  payment_method: null,
  invoices_id: null,
  start_datetime: null,
  end_datetime: null,
  created_at: null,
  amount: null,
  dates:[],
  hours:[],
  status: null,
  parkings_plans_clients_plans_id: null,
  type: null, // PACOM EVENT
  card_reader_id: null, // PACOM EVENT
  event_entry_datetime: null,
  event_exit_datetime: null,
  clients_groups_id: null
};


export {
  GMAPS_KEY,
  RECAPTCHA_KEY,
  GTM_CODE,
  SECRET_KEY,
  BASE_URL,
  FRONT_URL,
  API_DOMAIN,
  FRONT_DOMAIN,
  BASE_API,
  ADMIN_API,
  CLIENT_API,
  CLIENT_APP_API,
  CLIENT_API_CREDENTIALS,
  // BASE_OLD,
  // IS_OLD_API,
  FRANQUICIADO,
  ADMINISTRADOR,
  GESTOR,
  FRANQUICIADO_MODEL,
  ADMINISTRADOR_MODEL,
  GESTOR_MODEL,
  IMAGES_URL,
  PLAN_BASE_MODEL,
  PLAN_24H_MODEL,
  PLAN_NOCHE_MODEL,
  PLAN_FIN_SEMANA_MODEL,
  PLAN_CUATRO_DIAS_MODEL,
  PLAN_SEMANAL_MODEL,
  PLAN_SEMANAL_EJECUTIVO_MODEL,
  PLAN_MENSUAL_EJECUTIVO_MODEL,
  PLAN_MENSUAL_NOCHES_MODEL,
  PLAN_MENSUAL_MODEL,
  PLAN_LIBRE_MODEL,
  PRODUCTO_PER_MINUTE_MODEL,
};
